import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { graphql, StaticQuery } from 'gatsby'
import { stripIndent } from 'common-tags/es'
import aitoDataSource from '../../../assets/aito-data-source.svg'
import * as styles from './styles'
import dashLine from '../../../assets/dash-line.svg'
import { Section, Button, AnimatedWindowStack, CodeSnippet } from '..'

const propTypes = {
  data: PropTypes.object.isRequired
}

const searchQuery = stripIndent`
    {
      {
        "from": "documentation",
        "orderBy": {
          "$similarity": {
            "analyzedText": "how can I upload data"
            }
          },
        "select": ["sourceUrl", "fullText"]
      }
    }
    `
const queryResult = stripIndent`
    [{
      "sourceUrl": "https://github.com/aito...",
      "fullText": "# Aito tutorial modules..."
    }, ...]
    `

const WorkFlow = ({ data }) => {
  const button = (
    <styles.StyledLink to="/request-trial/">
      <Button size="small">
        {data.buttonText}
      </Button>
    </styles.StyledLink>
  )

  return (
    <styles.WorkflowContainer>
      <styles.SectionContainer>
        <styles.SectionRow>
          <styles.SectionCol sm={1} xs={0} />
          <styles.SectionCol sm={5} xs={12}>
            <styles.SectionSmallHeader>
              {data.workflowHeader}
            </styles.SectionSmallHeader>
          </styles.SectionCol>
        </styles.SectionRow>

        <Section>
          <styles.StepRow>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.StepSmallHeader>
                {data.step1SmallHeader}
              </styles.StepSmallHeader>
              <styles.StepBigHeader>
                {data.step1BigHeader}
              </styles.StepBigHeader>
              <styles.StepText>
                {data.step1Text}
              </styles.StepText>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.DataSourceImage src={aitoDataSource} alt="" />
            </styles.SectionCol>
          </styles.StepRow>

          <styles.DashLineContainer>
            <styles.DashLine src={dashLine} alt="" />
          </styles.DashLineContainer>

          <styles.StepRow reverse>
            <styles.SectionCol sm={5} xs={12}>
              <styles.StepSmallHeader>
                {data.step2SmallHeader}
              </styles.StepSmallHeader>
              <styles.StepBigHeader>
                {data.step2BigHeader}
              </styles.StepBigHeader>
              <styles.StepText>
                {data.step2Text}
              </styles.StepText>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.QueryContainer>
                <styles.QueryHeader>
                  {data.step2QueryHeader}
                </styles.QueryHeader>
                <styles.QueryBox>
                  <CodeSnippet language="javascript">
                    {searchQuery}
                  </CodeSnippet>
                </styles.QueryBox>
                <styles.QueryHeader>
                  {data.step2QueryHeaderResult}
                </styles.QueryHeader>
                <styles.QueryBox>
                  <CodeSnippet language="javascript">
                    {queryResult}
                  </CodeSnippet>
                </styles.QueryBox>
              </styles.QueryContainer>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
          </styles.StepRow>

          <styles.DashLineContainer>
            <styles.DashLineReverse src={dashLine} alt="" />
          </styles.DashLineContainer>

          <styles.StepRow>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <styles.StepSmallHeader>
                {data.step3SmallHeader}
              </styles.StepSmallHeader>
              <styles.StepBigHeader>
                {data.step3BigHeader}
              </styles.StepBigHeader>
              <styles.StepText>
                {data.step3Text}
              </styles.StepText>

              <styles.ButtonContainerDesktop>
                {button}
              </styles.ButtonContainerDesktop>
            </styles.SectionCol>
            <styles.SectionCol sm={1} xs={0} />
            <styles.SectionCol sm={5} xs={12}>
              <AnimatedWindowStack
                indicator={data.indicator}
                searchFormContent={data.searchForm}
              />
            </styles.SectionCol>
          </styles.StepRow>
        </Section>
        <styles.ButtonContainerMobile>
          {button}
        </styles.ButtonContainerMobile>
      </styles.SectionContainer>
    </styles.WorkflowContainer>
  )
}

WorkFlow.propTypes = propTypes

export default () => (
  <StaticQuery
    query={graphql`
      query GetWorkflow {
        allYaml(filter: {file: {eq: "workflow"}}) {
          edges {
            node {
              workflowHeader
              step1SmallHeader
              step1BigHeader
              step1Text

              step2SmallHeader
              step2BigHeader
              step2Text
              step2QueryHeader
              step2QueryHeaderResult

              step3SmallHeader
              step3BigHeader
              step3Text

              buttonText

              indicator {
                frontend
                backend
              }
              searchForm {
                inputText
                result1HeaderBefore
                result1HeaderKeyword
                result1HeaderAfter
                result1TextBefore
                result1TextKeyword
                result1TextAfter
                result2HeaderBefore
                result2HeaderKeyword
                result2HeaderAfter
                result2TextBefore
                result2TextKeyword
                result2TextAfter
                resultNumber
              }
            }
          }
        }
      }
    `
    }
    render={(data) => {
      const { allYaml } = data
      const { edges } = allYaml
      const { node } = _.first(edges)
      return (
        <WorkFlow data={node} />
      )
    }}
  />
)
